import React, { useState , useEffect } from 'react';
import { Row, Col, Button, Input, Label, Accordion, AccordionItem, Collapse, ModalBody, ModalHeader, Card, CardBody, Progress} from 'reactstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Table_list from './DB_Link_Component.js/Table_list';
import Pagination from '../../../Components/Common/Pagination_Cust';
import { GET_TABLE_DETAILS, Update_DB_Bot } from '../../../slices/thunks';
import { useDispatch } from 'react-redux';
import Loader from '../../../Components/Common/Loader';
import config from '../../../config';
import * as url from  "../../../helpers/url_helper"
import Upload_progressbar from '../../../Components/Common/Upload_progressbar';
// import Extract_Distinct_Data_Modal from '../../../Components/Common/Extract_Distinct_Data_Modal';


const Db_Link = () => {
    // Collapse with Icon
    const dispatch = useDispatch()
    const { Tables, selectedTables, total_record, total_pages, current_page ,TableStructurePayload ,loading , selected_table_count , Tables_Copy } = useSelector((state) => state.Table_Details)
    const BotDetails = useSelector((state) => state.BotDetails);
    const  create_new_bot_details =  useSelector((state) => state.Create_Bot)
    const [expandAll, setexpandAll] = useState(false)
    const [search_string, setsearch_string] = useState('')
    const [progress, setprogress] = useState(" ")
    const [status, setstatus] = useState("")

    
    const [filter, setfilter] = useState({

        databaseId: BotDetails.Bot_Details.Database_ID,
        page: current_page,
        page_size:config.general_config.PER_PAGE_CONTENT,
        search_term:"",
        Bot_ID:BotDetails.Bot_Details.Bot_ID,
        selectedonly:false
    })

    const onPageChange = (page_number) => {
        let filter_temp = filter
        filter_temp.page=parseInt(page_number)
        setfilter(filter_temp)
        dispatch(GET_TABLE_DETAILS(filter_temp))
    }

    const on_Search_Click = ()=>{
        let filter_temp = filter
        filter_temp.page=1
        filter_temp.search_term=search_string
        setfilter(filter_temp)
        dispatch(GET_TABLE_DETAILS(filter_temp))
    }


    const on_Click_Selected_Table_Only = (value)=>{
        let filter_temp = filter
        filter_temp.selectedonly=value
        setfilter(filter_temp)
        dispatch(GET_TABLE_DETAILS(filter_temp))
    }


    const update_DB_bot = () => {
        const {Assets_ID, Bot_ID , Database_ID ,Group_ID , Max_Record,Bot_Allow_See_Source , BOT_Category , Bot_Sample_Question , Model , Bot_Instructions  , Bot_Title , Bot_Description, structure} = BotDetails.Bot_Details
        
     let table_structure_payload_overwritten = [];

     console.log(TableStructurePayload)

// // Iterate over tables
// Tables_Copy.forEach((ele) => {
//     const table_name = ele.table_name;
//     const columns = ele.columns;
//     // Find the table in the existing structure
//     const find_in_existing_structure = TableStructurePayload.find((existingTable) => existingTable.table_name == table_name);
    
//     if (find_in_existing_structure) {
//         const checked_columns = [];

//         // Check for columns within the table
//         columns.forEach((column) => {
//             const column_name = column.column_name;
//             const type = column.column_data_type
//             const vector_column_distinct = column.vector_column_distinct
//             // Find the column in the existing table structure
//             const find_column_in_existing_structure = find_in_existing_structure.columns.filter((existingColumn) => (existingColumn.name == column_name && existingColumn.type == type  ));
            
//             if (find_column_in_existing_structure.length > 0) {
//                 checked_columns.push(find_column_in_existing_structure[0]); // Add matched column
//             }
//         });


//         table_structure_payload_overwritten.push({
//             ...find_in_existing_structure,
//             columns: checked_columns
//         });
//     }
// });
      
      console.log(table_structure_payload_overwritten, "Overwritten Structure ")
      
        dispatch(
        Update_DB_Bot({
          Bot_ID: Bot_ID,
          databaseId: Database_ID,
          Group_ID: Group_ID,
          max_record: Max_Record,
          bot_allow_see_source: Bot_Allow_See_Source,
          BOT_Category: BOT_Category,
          Bot_Sample_Question: Bot_Sample_Question,
          model: Model,
          instructions:Bot_Instructions,
          title: Bot_Title,
          description: Bot_Description,
          structure: TableStructurePayload,
          assistant_id:Assets_ID,
          page: current_page,
          page_size:config.general_config.PER_PAGE_CONTENT,
          search_term:search_string
            
          
        })
      );
    };


    useEffect(() => {
      if (!BotDetails.Bot_Details?.Bot_ID) return;
     
      console.log("Calling Event Source")
      const baseURL =
        window.location.hostname === "localhost"
          ? config.api.API_URL_LOCAL_HOST
          : config.api.API_URL;
    
      const endpoint = `${baseURL}${url.knowledge_upload_status}${BotDetails.Bot_Details.Bot_ID}`;
    
      // ensure previous is closed
      let eventSource = new EventSource(endpoint);
    
      const onProgress = (e) => {
        try {
          const data = JSON.parse(e.data);
          setprogress(data.progress.replaceAll("%",""));
          setstatus(data.status);
        } catch {}
      };
    
      const onCompleted = (e) => {
        try {
          const data = JSON.parse(e.data);
          setprogress(data.progress.replaceAll("%",""));
          setstatus(data.status);
          // finalize
        } catch {}
      };
    
      eventSource.addEventListener("upload-progress", onProgress);
      eventSource.addEventListener("upload-completed", onCompleted);
      eventSource.onmessage = (e) => {
        if (isValidJSON(e.data)) {
          const json_data = JSON.parse(e.data);
        }
      };
      eventSource.onerror = () => {
        // optionally eventSource.close();
      };
    
      // cleanup
      return () => {
        try {
          eventSource.removeEventListener("upload-progress", onProgress);
          eventSource.removeEventListener("upload-completed", onCompleted);
          eventSource.close();
        } catch {}
        eventSource = null;
      };
    }, [BotDetails.Bot_Details?.Bot_ID]); // <- only Bot_ID
    


    return (
        <>
            <Row>
                <Col>
                    <div className='tdtcs mb-2'>
                        <div className='tdc'>
                            <p>Total detected tables <b><span>{selected_table_count}/{total_record}</span></b></p>
                        </div>
                        {/* =========component bar========= */}
                 
                       {(parseInt(progress) != 0 && parseInt(progress) != 100 && progress !== " ") && <Upload_progressbar progress={progress} status={status} />}

                        {/* ==========end bar======== */}

                        <div className='sav_can_btn'>
                            {/* <button
                                type="button"
                                class="btn rounded-pill btn-light waves-effect"
                            >
                                Cancel
                            </button> */}
                            <button
                                type="button"
                                class="btn btn-secondary waves-effect waves-light"
                                onClick={update_DB_bot}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className='sss_db mb-2'>
                        <div className='super_select'>
                            <div className="form-check form-switch pr-5">
                                <Label className="form-check-label" htmlFor="flexSwitchCheckDefault">Selected tables only</Label>
                                <Input onChange={(e)=>{
                                    on_Click_Selected_Table_Only(e.target.checked)
                                }}  className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" />
                            </div>
                            <div className="form-check form-switch">
                                <Label className="form-check-label" htmlFor="flexSwitchCheckDefault">Expand all</Label>
                                <Input onChange={(e)=>{
                                   setexpandAll(e.target.checked)
                                }}  checked={expandAll} className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" />
                            </div>
                        </div>
                        <div className='search_db'>
                            <div onKeyDown={(e)=>{
                                 if(e.key === 'Enter'){
                                    
                                    on_Search_Click()
                                 }
                            }}  className="input-group">
                                <Input onChange={(e)=>{
                                    setsearch_string(e.target.value)
                                }} type="text" className="form-control h-40" placeholder="Search table name" aria-label="Search" />
                                <button onClick={on_Search_Click}  className="btn btn-secondary padd_10" type="button"><i className="bx bx-search fs-20"></i></button>
                            </div>
                        </div>
                    </div>

                </Col>
            </Row>
            <Row>
                <Col>
                <div className='d-flex naming_header'>
                    <div>Name</div>
                    <div> Extract Distinct Data</div>
                    <div>Alias</div>
                </div>
                </Col>
            </Row>
            <Card className='tabe-list-wrap'>
                <CardBody style={{padding:'0px'}}>
                    { (loading || create_new_bot_details.loading || BotDetails.loading || (parseInt(progress) != 0 && parseInt(progress) != 100 && progress !== " ")) ? <Loader/>: <Row>

                        {
                            Tables?.map((table) => {
                                return <Table_list expandAll={expandAll} table={table} />
                            })
                        }                      

                    </Row>}
                </CardBody>
            </Card>
            <Pagination onPageChange={onPageChange} total_pages={total_pages} current_page={current_page} />
        </>
    )
}

export default Db_Link
